import {type ClassValue, clsx} from 'clsx'
import {extendTailwindMerge} from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                'text-display',
                'text-h1',
                'text-h2',
                'text-h3',
                'text-h4',
                'text-body-large',
                'text-body',
                'text-body-small',
                'text-caption',
                'text-overline'
            ]
        }
    }
})

export function cn(...inputs: ClassValue[]): string {
    return customTwMerge(clsx(inputs))
}

export const focusClasses = 'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2'

export const transitionClasses = 'transition-[color,background-color,border-color,box-shadow,opacity] duration-normal ease-out'
